var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardAdalimumabSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 407 257",
    height: 270,
    width: 427,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #fff;        stroke: #231f20;        stroke-miterlimit: 10;      }      .cls-2 {        fill: none;      }      .cls-3 {        fill: #282561;      }      .cls-4 {        fill: #3dae2b;      }      .cls-5 {        fill: #8ec640;      }      .cls-6 {        fill: #c2d500;      }      .cls-7 {        fill: #231f20;      }      .cls-8, .cls-9 {        isolation: isolate;      }      .cls-10 {        fill: #662f90;      }      .cls-11, .cls-9 {        fill: #222d65;        font-family: Gotham-Book, 'Gotham Book';        font-size: 13.4px;      }      .cls-12 {        clip-path: url(#clippath);      }    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269.1,
    y: 200.4,
    width: 107.5,
    height: 27.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.2.5C9.3.5.5,9.4.5,20.2v216.6c0,10.9,8.8,19.7,19.7,19.7h366.7c10.9,0,19.7-8.9,19.7-19.7V20.2c0-10.9-8.8-19.7-19.7-19.7H20.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.8,94.7l-1,3.8h-3.4l4.4-14.7h4.2l4.4,14.7h-3.5l-1.1-3.8h-4.1,0ZM216.4,92.2l-.9-3.1c-.2-.9-.5-2-.7-2.8h0c-.2.9-.4,2-.7,2.8l-.9,3.1h3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M233,83v12.3c0,1.2,0,2.5,0,3.2h-2.9v-1.6h-.2c-.7,1.2-1.9,1.8-3.2,1.8-2.5,0-4.4-2.2-4.4-5.5,0-3.6,2.2-5.7,4.6-5.7s2.3.5,2.7,1.2h0v-5.8s3.2,0,3.2,0ZM229.8,92.3c0-.2,0-.4,0-.6-.2-.9-.9-1.6-1.9-1.6-1.5,0-2.2,1.3-2.2,3s.9,2.9,2.2,2.9,1.7-.7,1.9-1.6c0-.2,0-.5,0-.8v-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.5,98.5l-.2-1.1h0c-.7.8-1.7,1.3-3,1.3-2.1,0-3.4-1.6-3.4-3.3,0-2.8,2.4-4.1,6.1-4.1v-.2c0-.6-.3-1.4-1.9-1.4s-2.2.4-2.9.8l-.6-2.1c.7-.4,2.1-.9,4-.9,3.4,0,4.6,2.1,4.6,4.6v3.7c0,1,0,2,.1,2.6h-2.9ZM241.1,93.4c-1.7,0-3,.4-3,1.7s.6,1.3,1.3,1.3,1.5-.6,1.7-1.2c0-.2,0-.4,0-.6v-1.2h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 246.6,
    y: 83,
    width: 3.2,
    height: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.7,84.8c0,.9-.7,1.7-1.7,1.7s-1.7-.7-1.7-1.7c0-1,.7-1.7,1.7-1.7s1.7.7,1.7,1.7M252.4,87.8h3.2v10.7h-3.2v-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.1,91.2c0-1.3,0-2.5,0-3.4h2.7v1.4h.2c.4-.7,1.4-1.7,3.1-1.7s2.4.7,2.8,1.8h0c.4-.6.9-1,1.3-1.3.6-.3,1.2-.5,2-.5,2,0,3.5,1.4,3.5,4.6v6.3h-3.1v-5.8c0-1.6-.5-2.4-1.5-2.4s-1.3.5-1.5,1.2c0,.2-.1.6-.1.8v6.2h-3.1v-6c0-1.3-.5-2.3-1.5-2.3s-1.3.7-1.5,1.2c-.1.3-.1.6-.1.8v6.2h-3.1v-7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M285.9,95.1c0,1.4,0,2.5,0,3.4h-2.8v-1.5h-.2c-.4.7-1.4,1.8-3.2,1.8s-3.6-1.3-3.6-4.7v-6.3h3.2v5.8c0,1.6.5,2.5,1.6,2.5s1.4-.6,1.6-1.2c0-.2.1-.5.1-.7v-6.4h3.2v7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.5,91.2c0-1.3,0-2.5,0-3.4h2.7v1.4h.2c.4-.7,1.4-1.7,3.1-1.7s2.4.7,2.8,1.8h0c.4-.6.9-1,1.3-1.3.6-.3,1.2-.5,2-.5,2,0,3.5,1.4,3.5,4.6v6.3h-3.1v-5.8c0-1.6-.5-2.4-1.5-2.4s-1.3.5-1.5,1.2c0,.2-.1.6-.1.8v6.2h-3.1v-6c0-1.3-.5-2.3-1.5-2.3s-1.3.7-1.5,1.2c-.1.3-.1.6-.1.8v6.2h-3.1v-7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.5,98.5l-.2-1.1h0c-.7.8-1.7,1.3-3,1.3-2.1,0-3.4-1.6-3.4-3.3,0-2.8,2.4-4.1,6.1-4.1v-.2c0-.6-.3-1.4-1.9-1.4s-2.2.4-2.9.8l-.6-2.1c.7-.4,2.1-.9,4-.9,3.5,0,4.6,2.1,4.6,4.6v3.7c0,1,0,2,.1,2.6h-2.9ZM312.1,93.4c-1.7,0-3,.4-3,1.7s.5,1.3,1.3,1.3,1.5-.6,1.7-1.2c0-.2,0-.4,0-.6v-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.6,98.5c0-.7,0-2,0-3.2v-12.3h3.2v6.1h0c.6-.9,1.7-1.5,3.1-1.5,2.5,0,4.3,2.1,4.3,5.4,0,3.8-2.4,5.8-4.8,5.8s-2.4-.5-3.1-1.7h0v1.5h-2.9,0ZM320.9,93.9c0,.2,0,.4,0,.6.2.9,1,1.6,1.9,1.6,1.4,0,2.2-1.1,2.2-3s-.7-3-2.2-3-1.7.7-1.9,1.6c0,.2,0,.4,0,.6v1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.1,
    y: 91.7,
    width: 5.5,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.5,98.5l-.2-1.1h0c-.7.8-1.7,1.3-3,1.3-2.1,0-3.4-1.6-3.4-3.3,0-2.8,2.4-4.1,6.1-4.1v-.2c0-.6-.3-1.4-1.9-1.4s-2.2.4-2.9.8l-.6-2.1c.7-.4,2.1-.9,4-.9,3.5,0,4.6,2.1,4.6,4.6v3.7c0,1,0,2,.1,2.6h-2.9ZM343.1,93.4c-1.7,0-3,.4-3,1.7s.5,1.3,1.3,1.3,1.5-.6,1.7-1.2c0-.2,0-.4,0-.6v-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.5,98.5l-.2-1.1h0c-.7.8-1.7,1.3-3,1.3-2.1,0-3.4-1.6-3.4-3.3,0-2.8,2.4-4.1,6.1-4.1v-.2c0-.6-.3-1.4-1.9-1.4s-2.2.4-2.9.8l-.6-2.1c.7-.4,2.1-.9,4-.9,3.5,0,4.6,2.1,4.6,4.6v3.7c0,1,0,2,.1,2.6h-2.9ZM354.1,93.4c-1.7,0-3,.4-3,1.7s.5,1.3,1.3,1.3,1.5-.6,1.7-1.2c0-.2,0-.4,0-.6v-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.2,84.8v3.1h2.3v2.4h-2.3v3.9c0,1.3.3,1.9,1.3,1.9s.7,0,1,0v2.5c-.4.2-1.2.3-2.1.3s-1.9-.4-2.4-.9c-.6-.6-.9-1.7-.9-3.2v-4.4h-1.4v-2.4h1.4v-2.3l3.2-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.1,87.8l1.5,5.2c.2.6.4,1.4.5,2h0c.1-.6.3-1.4.5-2l1.3-5.2h3.5l-2.4,7c-1.5,4.2-2.5,5.9-3.6,7-1.1,1-2.3,1.3-3.1,1.5l-.7-2.8c.4,0,.9-.3,1.4-.6.5-.3,1-.8,1.3-1.3.1-.2.2-.3.2-.5s0-.3-.1-.6l-3.8-9.8h3.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(29.6 227.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ID:"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175,104.4c-1.6,0-3-1.1-3.4-2.7-.9-3.9-1.2-8-1.1-12.1.5-12.8,5.9-24.6,15.2-33.3s21.5-13.2,34.3-12.8c1.9,0,3.4,1.7,3.4,3.6,0,1.9-1.7,3.5-3.6,3.4-10.9-.4-21.3,3.5-29.3,10.9-8,7.4-12.6,17.5-13,28.4-.1,3.5.2,7,.9,10.3.4,1.9-.8,3.7-2.6,4.2-.2,0-.5,0-.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.3,139.1c-.6,0-1.2,0-1.8,0-16.9-.6-32.4-10.3-40.4-25.2-.9-1.7-.3-3.8,1.4-4.7s3.8-.3,4.7,1.4c6.8,12.7,20.1,21,34.5,21.5,9.3.4,18.2-2.4,25.7-7.9,1.6-1.1,3.7-.8,4.9.7,1.1,1.6.8,3.7-.7,4.9-8.3,6.1-18.1,9.3-28.3,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.4,72.2c-.9,0-1.7-.3-2.4-1-1.4-1.3-1.4-3.5-.1-4.9,4.5-4.7,10.2-8.1,16.6-9.8,11.1-2.9,23-.2,31.8,7.2,1.5,1.2,1.7,3.4.4,4.9-1.2,1.5-3.4,1.7-4.9.4-7.1-6-16.6-8.1-25.6-5.8-5.1,1.3-9.7,4.1-13.3,7.8-.7.7-1.6,1.1-2.5,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M206.4,123.8c-.4,0-.9,0-1.3-.3-10.4-4.3-18-12.9-20.9-23.8-1.7-6.3-1.6-13,.3-19.2.6-1.8,2.5-2.9,4.4-2.3,1.8.6,2.9,2.5,2.3,4.3-1.5,5-1.6,10.3-.3,15.4,2.3,8.7,8.4,15.7,16.8,19.1,1.8.7,2.6,2.8,1.9,4.6-.6,1.3-1.9,2.2-3.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.9,57.8c-1,0-1.9-.4-2.6-1.2-8.9-10.2-21.3-16.6-34.8-17.9-14.7-1.4-29.4,3.3-40.4,13.1-1.4,1.3-3.6,1.1-4.9-.3-1.3-1.4-1.1-3.7.3-4.9,12.5-11,29.1-16.5,45.7-14.8,15.3,1.5,29.3,8.7,39.4,20.3,1.3,1.5,1.1,3.7-.3,4.9-.7.6-1.5.9-2.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.1,148.1c-.4,0-.8,0-1.2-.2-25.3-9.6-41.1-35.1-38.5-62.1,1-10.4,4.8-20.4,10.8-28.9,1.1-1.6,3.3-1.9,4.9-.8,1.6,1.1,1.9,3.3.8,4.9-5.3,7.5-8.6,16.3-9.5,25.6-2.3,23.8,11.7,46.4,34,54.9,1.8.7,2.7,2.7,2,4.5-.5,1.4-1.9,2.2-3.3,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.2,151.7c-1.9,0-3.9,0-5.8-.3-.5,0-1-.1-1.5-.2-1.9-.2-3.3-2-3-3.9s2-3.3,3.9-3c.4,0,.9.1,1.4.1,14.8,1.4,29.6-3.4,40.6-13.3,1.4-1.3,3.6-1.2,4.9.3,1.3,1.4,1.2,3.6-.3,4.9-11.1,9.9-25.4,15.3-40.2,15.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M329.8,210.5h0c-.2,0-.5.1-.7.1-.2,0-.4,0-.7,0s-.7,0-1-.1c-.3,0-.6-.2-.9-.4s-.5-.4-.6-.8-.2-.7-.2-1.1,0-.8.2-1.1c.1-.3.3-.6.6-.8.2-.2.5-.4.9-.5.3-.1.7-.2,1.1-.2s.9,0,1.4.2v1c-.5-.2-.9-.3-1.3-.3s-.4,0-.6.1c-.2,0-.3.2-.5.3-.1.1-.2.3-.3.5,0,.2-.1.4-.1.6,0,.5.1.8.4,1.1.3.3.7.4,1.1.4s.4,0,.6,0c.2,0,.4-.1.6-.2v1c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "330.2 205.9 333.5 205.9 333.5 206.8 331.4 206.8 331.4 207.8 333.4 207.8 333.4 208.7 331.4 208.7 331.4 209.7 333.6 209.7 333.6 210.6 330.2 210.6 330.2 205.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "334.2 205.9 335.5 205.9 335.5 209.7 337.4 209.7 337.4 210.6 334.2 210.6 334.2 205.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "337.8 205.9 339.1 205.9 339.1 209.7 341.1 209.7 341.1 210.6 337.8 210.6 337.8 205.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "341.5 206.8 340.4 206.8 340.4 205.9 344 205.9 344 206.8 342.8 206.8 342.8 210.6 341.5 210.6 341.5 206.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M344.3,205.9h2.2c.5,0,.8.1,1.1.3.3.2.4.5.4.9,0,.6-.3,1.1-.9,1.2h0c.1,0,.2.1.3.2s.1.3.2.5c0,.1.1.3.1.4l.5,1.3h-1.3l-.3-.9c0-.2-.1-.4-.2-.5,0-.1-.1-.2-.2-.3s-.1-.1-.2-.2c0,0-.2,0-.3,0h-.3v1.9h-1.3v-4.7h0ZM345.6,207.9h.3c.1,0,.2,0,.4,0s.2,0,.3,0c0,0,.2,0,.2-.2s0-.2,0-.3,0-.2,0-.3c0,0-.1-.1-.2-.2-.1,0-.4-.1-.6-.1h-.3v1.1h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 348.8,
    y: 205.9,
    width: 1.3,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.3,206.5c.4-.4,1-.6,1.8-.6s1.4.2,1.8.6c.4.4.6,1,.6,1.8s-.2,1.4-.6,1.8c-.4.4-1,.6-1.8.6s-1.4-.2-1.8-.6-.6-1-.6-1.8.2-1.4.6-1.8M352.1,208.8c0,.2.1.3.2.5,0,.1.2.2.3.3.1,0,.3.1.5.1s.4,0,.5-.1c.1,0,.2-.2.3-.3s.1-.3.2-.5,0-.4,0-.6,0-.4,0-.6-.1-.3-.2-.5-.2-.2-.3-.3c-.1,0-.3-.1-.5-.1s-.3,0-.5.1-.2.2-.3.3-.1.3-.2.5,0,.4,0,.6,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "356 205.9 357.6 205.9 359.2 209.1 359.3 209.1 359.2 205.9 360.4 205.9 360.4 210.6 358.8 210.6 357.2 207.4 357.2 207.4 357.2 210.6 356 210.6 356 205.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.2,208.8c0,.6-.2,1.1-.6,1.4-.4.3-.9.5-1.5.5s-1.1-.2-1.5-.5c-.4-.3-.6-.8-.6-1.4v-2.9h1.3v2.7c0,.2,0,.3,0,.5,0,.1,0,.3.1.4,0,.1.1.2.2.2.1,0,.2,0,.4,0s.3,0,.4,0,.2-.1.2-.2.1-.2.1-.4c0-.1,0-.3,0-.5v-2.7h1.3v2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.9,209.4c.2.1.4.2.6.2s.5,0,.7,0,.4,0,.6-.1c.1,0,.2-.2.2-.4s0-.3-.2-.4c-.1,0-.4-.2-.6-.3-.2,0-.4-.1-.5-.2s-.3-.1-.4-.2-.2-.2-.3-.4c0-.2-.1-.4-.1-.6s0-.5.2-.7.3-.3.5-.4.4-.2.7-.2.5,0,.8,0,.4,0,.7,0c.2,0,.4,0,.6.1v1c-.4-.1-.8-.2-1.1-.2s-.2,0-.3,0c0,0-.2,0-.3,0s-.2,0-.2.1c0,0,0,.1,0,.2s0,.2.2.3c.1,0,.3.1.6.2.2,0,.4.1.5.2.1,0,.3.1.4.2.1.1.2.2.3.4,0,.2.1.4.1.6s0,.5-.2.8c-.1.2-.3.4-.5.5-.2.1-.4.2-.7.2-.2,0-.5,0-.8,0s-.5,0-.7,0c-.2,0-.5,0-.7-.1v-1c.1,0,.1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M373.3,205.9h1.5l1.8,4.7h-1.4l-.4-1h-1.8l-.4,1h-1.3l1.8-4.7h0ZM374,206.9h0l-.6,1.9h1.2l-.6-1.9h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "298.4 215.5 307.2 215.5 307.2 217.9 302.5 217.9 302.5 220 306.8 220 306.8 222.5 302.5 222.5 302.5 224.8 307.3 224.8 307.3 227.2 298.4 227.2 298.4 215.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "309.4 215.5 313.5 215.5 313.5 224.3 318.1 224.3 318.1 227.2 309.4 227.2 309.4 215.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "319.4 215.5 323.6 215.5 323.6 224.3 328.2 224.3 328.2 227.2 319.4 227.2 319.4 215.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "337.3 215.4 327.5 215.4 327.5 216.3 331.9 216.3 331.9 227.3 332.9 227.3 332.9 216.3 337.4 216.3 337.4 215.4 337.3 215.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M345.2,223.1c-.6-.8-1-1.4-1.5-1.8,1.5-.6,2.2-1.5,2.2-2.9s-.4-3.1-4-3.1h-3.1v11.9h1v-5.6h1.5c1.4,0,1.8.2,3.2,2.4l2.1,3.2h1.1s.1,0,.1,0l-2.7-4.2h0ZM339.9,216.3h1.9c1.9,0,3,.8,3,2.2s-1.1,2.3-3,2.3h-1.9v-4.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "350.2 215.4 349.2 215.4 349.2 227.3 350.2 227.3 350.2 215.4 350.2 215.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M358,215.2c-3.5,0-6.3,2.7-6.3,6.1s2.8,6.1,6.3,6.1,6.3-2.7,6.3-6.1-2.8-6.1-6.3-6.1M358,226.5c-2.9,0-5.2-2.3-5.2-5.1s2.3-5.1,5.2-5.1,5.2,2.3,5.2,5.1-2.3,5.1-5.2,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M376.5,215.4h-1v10.2c-.2-.2-8.8-10.2-8.8-10.2h-.8s0,0,0,0v11.9h1v-10.2c.2.2,8.8,10.2,8.8,10.2h.8s0,0,0,0v-11.9h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.3,224c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,1.7.5,2.1,1.2h4.1c-.6-2.9-3.2-5-6.2-5s-6.4,2.9-6.4,6.4,2.9,6.4,6.4,6.4,5.8-2.4,6.3-5.4h-4c-.4.9-1.3,1.6-2.4,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.1,200.4c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3,6.3-2.8,6.3-6.3-2.8-6.3-6.3-6.3M290.1,210.2c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6,3.6,1.6,3.6,3.6-1.6,3.6-3.6,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.1,221.3c0,3.5,2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3-2.8-6.3-6.3-6.3-6.3,2.8-6.3,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.4,200.4c-3.5,0-6.3,2.8-6.3,6.2s2.8,6.3,6.3,6.3,6.2-2.8,6.2-6.3-2.8-6.2-6.2-6.2M275.4,211.9c-2.9,0-5.3-2.4-5.3-5.3s2.4-5.3,5.3-5.3,5.3,2.4,5.3,5.3-2.4,5.3-5.3,5.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M49.9,69.9c-.2,0-.5-.1-.6-.3-1.1-1.7-2.7-3-4.6-3.6-.4-.1-.6-.6-.5-.9.1-.4.5-.6.9-.5,2.2.7,4.2,2.2,5.4,4.2.2.3.1.8-.2,1-.1,0-.3.1-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.7,77.1c-.3,0-.7-.2-.7-.6-.2-.8-.3-1.7-.2-2.6.1-2.7,1.2-5.2,3.2-7.1s4.6-2.8,7.3-2.7c.4,0,.7.4.7.8,0,.4-.4.7-.8.7-2.3,0-4.5.7-6.2,2.3s-2.7,3.7-2.8,6c0,.7,0,1.5.2,2.2,0,.4-.2.8-.6.9,0,0-.1,0-.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,84.4h-.4c-3.6-.1-6.9-2.2-8.6-5.4-.2-.4,0-.8.3-1s.8,0,1,.3c1.5,2.7,4.3,4.5,7.3,4.6,2,0,3.9-.5,5.5-1.7.3-.2.8-.2,1,.2.2.3.2.8-.2,1-1.8,1.3-3.8,2-6,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.1,70.2c-.2,0-.4,0-.5-.2-.3-.3-.3-.8,0-1.1,1-1,2.2-1.7,3.5-2.1,2.4-.6,4.9,0,6.8,1.5.3.3.3.7,0,1.1-.3.3-.7.3-1,0-1.5-1.3-3.5-1.7-5.4-1.2-1.1.3-2.1.9-2.8,1.7-.2.2-.3.2-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.4,81.2c0,0-.2,0-.3,0-2.2-.9-3.8-2.8-4.4-5.1-.3-1.3-.3-2.8,0-4.1.1-.4.5-.6.9-.5.4.1.6.5.5.9-.3,1.1-.3,2.2,0,3.3.5,1.9,1.8,3.3,3.6,4.1.4.2.6.6.4,1-.1.3-.4.5-.7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.3,81.7c-.4,0-.7-.3-.7-.7,0-.4.3-.8.7-.8.4,0,.8,0,1.3-.2,1-.2,1.8-.7,2.5-1.4.3-.3.8-.3,1,0s.3.8,0,1.1c-.9.8-2,1.4-3.2,1.7-.5.1-1,.2-1.6.2h0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.7,
    y: 51.4,
    width: 130.2,
    height: 51.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,67.1c-.2,0-.4,0-.6-.2-1.9-2.2-4.5-3.5-7.4-3.8-3.1-.3-6.2.7-8.6,2.8-.3.3-.8.2-1,0-.3-.3-.2-.8,0-1.1,2.7-2.3,6.2-3.5,9.7-3.2,3.3.3,6.2,1.8,8.4,4.3.3.3.2.8,0,1.1-.1.1-.3.2-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.7,86.3c0,0-.2,0-.3,0-5.4-2-8.8-7.5-8.2-13.2.2-2.2,1-4.3,2.3-6.2.2-.3.7-.4,1-.2.3.2.4.7.2,1-1.1,1.6-1.8,3.5-2,5.4-.5,5.1,2.5,9.9,7.2,11.7.4.2.6.6.4,1-.1.3-.4.5-.7.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.1,
    y: 51.4,
    width: 105.3,
    height: 47.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.9,87.1c-.4,0-.8,0-1.2,0-.1,0-.2,0-.3,0-.4,0-.7-.4-.7-.8s.4-.7.8-.7c0,0,.2,0,.3,0,3.1.3,6.3-.7,8.6-2.8.3-.3.8-.2,1,0,.3.3.2.8,0,1.1-2.3,2.1-5.4,3.3-8.5,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.4,63.7h4.6l9.7,22.7h-5.2l-2.1-5.1h-9.5l-2.1,5.1h-5s9.6-22.7,9.6-22.7ZM66.7,77l-3-7.3-3,7.3h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.2,63.9h10.3c2.9,0,5.1.8,6.6,2.3,1.2,1.2,1.9,3,1.9,5.2h0c0,3.7-2,6-4.8,7l5.5,8h-5.8l-4.8-7.2h-3.9v7.2h-4.9v-22.5h0ZM87.2,74.8c2.4,0,3.8-1.3,3.8-3.2h0c0-2.2-1.5-3.3-3.9-3.3h-4.9v6.5h5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.5 63.9 115.5 63.9 115.5 68.3 103.4 68.3 103.4 72.8 114.1 72.8 114.1 77.2 103.4 77.2 103.4 82 115.7 82 115.7 86.4 98.5 86.4 98.5 63.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.6,83.1l2.9-3.5c2,1.7,4.2,2.7,6.7,2.7s3.2-.8,3.2-2.1h0c0-1.3-.8-2-4.5-2.9-4.5-1.2-7.5-2.4-7.5-6.9h0c0-4.1,3.3-6.8,7.9-6.8s6.1,1,8.4,2.9l-2.6,3.7c-2-1.4-4-2.2-5.8-2.2s-2.9.9-2.9,2h0c0,1.5,1,2,4.9,3,4.6,1.2,7.1,2.8,7.1,6.8h0c0,4.5-3.4,7-8.3,7s-6.8-1.2-9.6-3.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "91.1 52.4 88.3 52.4 88.3 59.6 87.8 59.6 87.8 52.4 85 52.4 85 51.9 91.1 51.9 91.1 52.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94,51.7c1.8,0,2.5,1,2.5,2s-.5,1.5-1.4,1.9c.3.2.6.6,1,1.2l1.7,2.7h-.7l-1.3-2.1c-.9-1.5-1.2-1.6-2.1-1.6h-1v3.7h-.6v-7.7h1.9ZM92.7,55.2h1.2c1.3,0,1.9-.6,1.9-1.5s-.6-1.5-2-1.5h-1.2v3h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.8,
    y: 51.7,
    width: 0.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.3,59.5c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9,3.9,1.7,3.9,3.9-1.7,3.9-3.9,3.9M104.3,52.2c-1.9,0-3.3,1.5-3.3,3.4s1.5,3.4,3.3,3.4,3.3-1.5,3.3-3.4-1.4-3.4-3.3-3.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "116 59.4 115.6 59.4 109.9 52.7 109.9 59.4 109.3 59.4 109.3 51.7 109.8 51.7 115.5 58.4 115.5 51.7 116 51.7 116 59.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "66.3 51.8 71.8 51.8 71.8 53.5 68.8 53.5 68.8 54.7 71.7 54.7 71.7 56.4 68.8 56.4 68.8 57.7 71.8 57.7 71.8 59.4 66.3 59.4 66.3 51.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "79.8 51.8 82.3 51.8 82.3 57.6 85.3 57.6 85.3 59.4 79.8 59.4 79.8 51.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "73.4 51.8 75.9 51.8 75.9 57.6 78.9 57.6 78.9 59.4 73.4 59.4 73.4 51.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1,56.5c-.4,1.8-2,3.2-4.1,3.2s-4.2-1.9-4.2-4.2,1.8-4.2,4.2-4.2,3.8,1.4,4.2,3.3h-2.4c-.2-.5-.7-1.1-1.7-1.1-.5,0-1,.2-1.4.5-.3.4-.5.9-.5,1.4,0,1.1.8,2,1.9,2s1.4-.6,1.7-1h2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.8,95.8h0c0-1.6,1.2-2.8,2.8-2.8s1.6.3,2.1.9l-.4.4c-.5-.4-1-.8-1.7-.8-1.2,0-2.1,1-2.1,2.2h0c0,1.3.9,2.3,2.1,2.3s1.2-.3,1.8-.8l.4.4c-.6.6-1.2,1-2.2,1-1.6,0-2.7-1.2-2.7-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.4,95.8h0c0-1.5,1.1-2.8,2.8-2.8s2.8,1.3,2.8,2.8h0c0,1.5-1.1,2.8-2.8,2.8s-2.8-1.3-2.8-2.8M56.3,95.8h0c0-1.3-.9-2.3-2.2-2.3s-2.1,1-2.1,2.2h0c0,1.3.9,2.3,2.2,2.3s2.1-1,2.1-2.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 58,
    y: 95.9,
    width: 2.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.4,93.1h2c1.2,0,2.1.7,2.1,1.7h0c0,1.2-1,1.8-2.2,1.8h-1.3v1.9h-.6v-5.5ZM63.4,96.1c.9,0,1.5-.5,1.5-1.2h0c0-.8-.6-1.2-1.5-1.2h-1.4v2.4s1.3,0,1.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.2,93.1h.6l2.5,5.5h-.7l-.6-1.4h-3l-.7,1.4h-.6s2.5-5.5,2.5-5.5ZM69.7,96.6l-1.2-2.8-1.2,2.8h2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "73.2 96.4 70.9 93.1 71.6 93.1 73.5 95.8 75.3 93.1 76.1 93.1 73.8 96.4 73.8 98.6 73.2 98.6 73.2 96.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.4,93.1h2.1c1.2,0,2.1.7,2.1,1.7h0c0,1.2-1,1.8-2.2,1.8h-1.3v1.9h-.6v-5.5ZM81.3,96.1c.9,0,1.5-.5,1.5-1.2h0c0-.8-.6-1.2-1.5-1.2h-1.4v2.4s1.3,0,1.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.6,93.1h2.3c.7,0,1.2.2,1.6.6.3.3.4.7.4,1.1h0c0,.9-.6,1.5-1.5,1.6l1.7,2.2h-.8l-1.6-2.1h-1.6v2.1h-.6v-5.5h0ZM86.9,95.9c.8,0,1.4-.4,1.4-1.1h0c0-.7-.5-1.1-1.4-1.1h-1.7v2.2h1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90,95.8h0c0-1.5,1.1-2.8,2.8-2.8s2.8,1.3,2.8,2.8h0c0,1.5-1.1,2.8-2.8,2.8s-2.8-1.3-2.8-2.8M94.9,95.8h0c0-1.3-.9-2.3-2.2-2.3s-2.1,1-2.1,2.2h0c0,1.3.9,2.3,2.2,2.3s2.1-1,2.1-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.7,95.8h0c0-1.5,1.1-2.8,2.7-2.8s1.5.3,2,.7l-.4.5c-.4-.4-.9-.6-1.7-.6-1.2,0-2.1,1-2.1,2.2h0c0,1.3.8,2.3,2.2,2.3s1.2-.2,1.6-.6v-1.4h-1.7v-.6h2.3v2.2c-.5.4-1.3.8-2.2.8-1.7,0-2.8-1.2-2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103,93.1h2.3c.7,0,1.2.2,1.6.6.3.3.4.7.4,1.1h0c0,.9-.6,1.5-1.5,1.6l1.7,2.2h-.8l-1.6-2.1h-1.6v2.1h-.6v-5.5h0ZM105.3,95.9c.8,0,1.4-.4,1.4-1.1h0c0-.7-.5-1.1-1.4-1.1h-1.7v2.2h1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.7,93.1h.6l2.5,5.5h-.7l-.6-1.4h-3l-.7,1.4h-.6s2.5-5.5,2.5-5.5ZM112.2,96.6l-1.2-2.8-1.2,2.8h2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "114.8 93.1 115.5 93.1 117.5 96.1 119.5 93.1 120.1 93.1 120.1 98.6 119.5 98.6 119.5 94.1 117.5 97.1 117.4 97.1 115.5 94.2 115.5 98.6 114.8 98.6 114.8 93.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.7,
    y: 51.4,
    width: 130.2,
    height: 51.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(29.6 147.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxBIN: ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(86.7 147.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "610524"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(29.6 167.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxPCN: ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(86.7 167.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Loyalty"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(29.6 187.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxGRP:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(86.7 187.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50778109"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(29.6 207.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ISSUER:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(86.7 207.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(80840)")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAdalimumabSmall);
export default __webpack_public_path__ + "static/media/card-adalimumab-small.7ecbf981e9f8f1d952c2d254188b6a76.svg";
export { ForwardRef as ReactComponent };